export default sub => (error) => {
  if (!error) return;
  let errData;
  if (error.response) {
    if (error.response.data) {
      errData = error.response.data;
    }
  } else if (error.request) {
    const site = location.pathname.match(/^\/(kcl|ktc|ktr|kilt|fiti)/g)[0];
    if (location.pathname.indexOf(`${site}/admin`) === 0) location.href = `${site}/admin/login`;
    else if (location.pathname.indexOf(`${site}/judge`) === 0) location.href = `${site}/judge/login`;
    else if (location.pathname.indexOf(`${site}/committee`) === 0) location.href = `${site}/committee/login`;
    else location.href = site;
  }

  if (error.data) {
    errData = error.data;
  }
  if (!errData) {
    console.error(error);
    return;
  }
  if (errData.code) {
    if (sub && sub(errData)) return;
    else if (errData.code === 'GO_404') {
      window.location.href = '/404';
      return;
    }
  }
  alert(errData.message || errData);
};



// WEBPACK FOOTER //
// ./src/utils/ErrorHandler.js